export default __webpack_public_path__ + "static/media/item-3.8552db4e.webp";